import React from 'react';

/**
 * Dialog — centred modal with scrim. Controlled via `open`.
 * Header (title + close), body (children), optional footer.
 */
export function Dialog({ open = false, onClose, title, description, footer, width = 460, children, style = {} }) {
  if (!open) return null;
  return (
    <div
      role="dialog" aria-modal="true"
      style={{ position: 'fixed', inset: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
    >
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(10, 14, 23, 0.45)', backdropFilter: 'blur(2px)' }} />
      <div
        style={{
          position: 'relative', width: '100%', maxWidth: width, background: 'var(--surface-card)',
          border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-lg)',
          overflow: 'hidden', ...style,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, padding: '20px 22px 0' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {title && <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-h3)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-strong)', letterSpacing: 'var(--ls-heading)' }}>{title}</span>}
            {description && <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--text-muted)', lineHeight: 'var(--lh-normal)' }}>{description}</span>}
          </div>
          <button type="button" aria-label="Schließen" onClick={onClose} style={{ display: 'inline-flex', width: 32, height: 32, alignItems: 'center', justifyContent: 'center', border: 'none', background: 'transparent', color: 'var(--text-faint)', cursor: 'pointer', borderRadius: 'var(--radius-sm)' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style={{ padding: '16px 22px', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-base)', color: 'var(--text-body)', lineHeight: 'var(--lh-normal)' }}>
          {children}
        </div>
        {footer && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 22px', borderTop: '1px solid var(--border-subtle)', background: 'var(--ink-50)' }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
